export default "__VITE_ASSET__507957fd__"